exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ninput[type=\"color\"] {\n    -webkit-appearance: none;\n    border: none;\n    width: 24px;\n    height: 24px;\n    padding:0px;\n}\ninput[type=\"color\"]::-webkit-color-swatch-wrapper {\n    padding: 0;\n}\ninput[type=\"color\"]::-webkit-color-swatch {\n    border: none;\n}\n", ""]);

// exports
